module.exports = __webpack_public_path__ + "static/media/14.e05d9f60.jpg";